module.exports = __webpack_public_path__ + "static/media/otp_valid.463ba8e8.png";